@import "./tokens.scss";

:root {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background: var(--color-canvas);
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: var(--color-scrollbar-thumb) var(--color-scrollbar-track);
}

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-track {
  background: var(--color-scrollbar-track);
}

*::-webkit-scrollbar-thumb {
  min-height: 2rem;
  border: 2px solid var(--color-scrollbar-track);
  border-radius: var(--radius-pill);
  background: var(--color-scrollbar-thumb);
}

*::-webkit-scrollbar-thumb:hover {
  background: var(--color-scrollbar-thumb-hover);
}

*::-webkit-scrollbar-corner {
  background: var(--color-scrollbar-corner);
}

body {
  background: var(--color-canvas);
  color: var(--color-ink);
  margin: 0;
  min-width: 320px;
}

button,
input,
select,
textarea {
  font: inherit;
}

:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
  box-shadow: none;
}

::selection {
  background: var(--color-selection);
  color: var(--color-ink);
}

.workflow-grid {
  background-image:
    linear-gradient(var(--color-border) 1px, transparent 1px),
    linear-gradient(90deg, var(--color-border) 1px, transparent 1px);
  background-size: 24px 24px;
}

@media (max-width: 1199px) {
  .dashboard-page,
  .cameras-page,
  .alerts-page,
  .events-page {
    .sidebar {
      width: 76px;
      align-items: center;
      padding-right: 0.75rem;
      padding-left: 0.75rem;
    }

    .main {
      margin-left: 76px;
    }

    .brand-copy,
    .brand-name,
    .navigation-title,
    .navigation-label,
    .navigation-count,
    .operator-copy {
      display: none;
    }

    .navigation-link,
    .operator {
      justify-content: center;
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }
  }
}

@media (max-width: 767px) {
  .dashboard-page,
  .cameras-page,
  .alerts-page,
  .events-page {
    .sidebar {
      width: 60px;
      padding-right: 0.5rem;
      padding-left: 0.5rem;
    }

    .main {
      margin-left: 60px;
    }

    .header,
    .content {
      padding-right: 1rem;
      padding-left: 1rem;
    }

    .header {
      align-items: flex-start;
      flex-direction: column;
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    .dashboard-grid,
    .summary,
    .camera-grid,
    .recent-list {
      grid-template-columns: 1fr;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
